import React, { useState } from "react";
import { NewInput } from "../..";
import { NewFieldStyles, NewFieldTypes, ValueSteps } from "../../../Definitions";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { CellContext, Row } from "@tanstack/react-table";
import { focus_view } from "../../../Assets/Glyphs/focusView";

export interface StepOptions<T> {
  valueStep: ValueSteps,
  maxValueNumber: number | undefined | ((rowId: number) => number);
  minValueNumber?: (rowId: number) => number;
}

export const NumberTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, cell, valueStep, maxValueNumber, minValueNumber}: CellContext<T, number | undefined> & EditAbleCell<T> & StepOptions<T>) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const onBlur = () => {
    if (value !==initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, value, row);
    }
  }
  let maxValue;
  if (maxValueNumber !== undefined && typeof maxValueNumber === "number") {
    maxValue = maxValueNumber;
  }
  if (maxValueNumber !== undefined && typeof maxValueNumber === "function") {
    maxValue = maxValueNumber(row.original.id);
  }
  let minValue = 0;
  if (minValueNumber !== undefined) {
    minValue = minValueNumber(row.original.id);
  }
  const isStatic = typeof staticColumn === "function" ? staticColumn(row) : staticColumn;
  return <StyledNumberCell staticColumn={isStatic} key={cell.id} keyPass={cell.id+"Input"} onBlur={onBlur} onChange={(e: number) => setValue(e)} canEdit={canEdit} cellData={{value}} valueStep={valueStep} maxValueNumber={maxValue} minValueNumber={minValue}/>
}

const StyledNumberCell = <T extends IdentifiableRow> ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn, valueStep, maxValueNumber, minValueNumber, focus_view}: StyledTableCellProps & EditAbleCell<T> & {valueStep:ValueSteps, maxValueNumber:number | undefined, minValueNumber: number | undefined} ) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5  }} key={keyPass}>
          {String(cellData.value) ?? ''}
        </div>
      );
    } else {
      return (
        <NewInput
          onBlur={onBlur}
          key={keyPass}
          onChange={onChange}
          fieldOverrides={{
            fieldStyle: NewFieldStyles.greyTertiary,
            fieldType: NewFieldTypes.tertiaryField,
            fieldWidth: "100%",
            focus_view: focus_view
          }}
          valueOverrides={{
            defaultValue: cellData.value,
            valueType: "number",
            valueStep: valueStep,
            minValueNumber,
            maxValueNumber
          }}
        />
      );
    }
  }

  return (cellData.value)

}